import { useTranslation } from "react-i18next";
import { FontColorsOutlined } from "@ant-design/icons";
import { Col, Modal, Row, Tabs, TabsProps, Typography } from "antd";
import React, { ReactNode } from "react";
import "./index.scss";
import Multimedia from "./multimedia";
import References from "./references";

type Props = {
  open: boolean;
  closeIcon: boolean;
  title: string;
  okText: string;
  cancelText: string;
  closeModal: (value: boolean) => void;
  confirm: () => void;
  icon: ReactNode;
  multimediaType: React.Dispatch<React.SetStateAction<string>>;
  isCheckDocument?: boolean;
};

export default function AddLessionModal(props: Props) {
  const { t } = useTranslation();
  const {
    open,
    title,
    closeIcon,
    okText,
    cancelText,
    closeModal,
    icon,
    confirm,
    multimediaType,
    isCheckDocument = true
  } = props;

  const onOk = () => {
    confirm();
  };

  const mockData = [
    {
      id: 1,
      title: t("Bài tập, bài kiểm tra, bài thi", "Bài tập, bài kiểm tra, bài thi"),
      desc: t("Cung cấp cơ hội củng cố kiến thức, kỹ năng và hiểu biết của học viên trong các bài tập, bài kiểm tra, bài thi cụ thể.", "Cung cấp cơ hội củng cố kiến thức, kỹ năng và hiểu biết của học viên trong các bài tập, bài kiểm tra, bài thi cụ thể."),
    }
  ]

  const itemsTab: TabsProps["items"] = [
    {
      key: "1",
      label: t("Đa phương tiện", "Đa phương tiện"),
      children: (
        <div className="waiting-assignment">
          <Multimedia isCloseModal={closeModal} multimediaType={multimediaType} />
        </div>
      ),
    },
    ...isCheckDocument ? [{
      key: "2",
      label: t("Đánh giá", "Đánh giá"),
      children: (
        <div className="assigned">
          <Row className='row-content'>
            <Col md={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 24 }} xs={{ span: 24 }}>
              {
                mockData.map((item, index) => (
                  <Row className='review-course-list p-3' onClick={confirm} key={index + 1}>
                    <>
                      <Col md={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 24 }} xs={{ span: 24 }}>
                        <Row>
                          <Col md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }} xs={{ span: 4 }} className='svg-icon'>
                            <FontColorsOutlined />
                          </Col>

                          <Col md={{ span: 20 }} lg={{ span: 20 }} xl={{ span: 240 }} xs={{ span: 20 }}>
                            <Typography.Title level={5}>
                              {item.title}
                            </Typography.Title>
                            <Typography.Text className="sub-title">
                              {item.desc}
                            </Typography.Text>
                          </Col>
                        </Row>
                      </Col>
                    </>
                  </Row>
                ))
              }
            </Col>
            {/* <Col md={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 24 }} xs={{ span: 24 }} className='col-button'>
              <Button type="primary" onClick={confirm}>{t("Chuyển tiếp", "Chuyển tiếp")}</Button>
            </Col> */}
          </Row>

        </div>
      ),
    },
    {
      key: "3",
      label: t("Tài liệu tham khảo", "Tài liệu tham khảo"),
      children: (
        <div className="waiting-assignment">
          <References isCloseModal={closeModal} multimediaType={multimediaType} />
        </div>
      ),
    }] : []

  ];

  return (
    <Modal
      className="add-lession-modal"
      title={
        <>
          {icon} <span>{title}</span>
        </>
      }
      closeIcon={closeIcon}
      centered
      open={open}
      okText={okText}
      cancelText={cancelText}
      onOk={onOk}
      onCancel={() => closeModal(false)}
      footer={null}
      maskClosable={false}
    >
      <Row gutter={16}>
        <Col
          md={{ span: 24 }}
          lg={{ span: 24 }}
          xl={{ span: 24 }}
          xs={{ span: 24 }}
        >
          <Tabs tabPosition={"left"} items={itemsTab} />
        </Col>
      </Row>
    </Modal>
  );
}
